<template>
  <div class="footer" >
    <div class="con">

    <div class="left">
      <a href="http://bszs.conac.cn/sitename?method=show&id=261E22F05BD91ACEE053022819ACACE7" target="_blank">
      <img src="@/assets/images/footer.png" alt="">
    </a>
    </div>
    
    <div class="right">
      <p>
        地址：合肥市包河区中山路1号省行政中心3号楼 邮编：230091
      </p>
      <p>
        版权所有：中国人民政治协商会议安徽省委员会 皖ICP备05003837号-1 皖公网安备34011102000447号
      </p>
    </div>
    <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {}
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => []
    }
  },
  created() {},
  methods: {}
}
</script>
<style scoped lang="less">
.footer {
  box-sizing: border-box;
  padding: 45px 0;
  text-align: center;
  background-color: #cf0016;
  color: #fff;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
  .con{
    width: 1200px;
margin: 0 auto;
  }
  .left{
    float: left;
    width:20%;
  }
  .right{
    float: left;
    width: 63%;
  }
  .clear{
    clear: both;
  }
}
</style>